import './ReceiptUploadPage.css'

import { useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { useUpdateUserPackage } from '../../../api/user-package/mutations/useUpdateUserPackage'
import checkMark from '../../../imgs/correct.svg'
import infoIcon from '../../../imgs/info.png'
import returnIcon from '../../../imgs/next.png'
import { uploadReceipt } from '../../../services/files'
import { setPackageForPayment } from '../../../store/packageSlice'
import TheFooter from '../TheFooter'

export default function ReceiptUploadPage() {
  const history = useHistory()
  const dispatch = useDispatch()
  const { mutateAsync: updatePackageMutation } = useUpdateUserPackage()
  const packageForReceiptUpload =
    useSelector(state => state.packages).packageForReceiptUpload ?? JSON.parse(localStorage.getItem('upload-page-package'))
  const { EURToUSD, GBPToUSD } = useSelector(state => state.packages)
  // const packageForReceiptUpload = null;

  //UI & terms
  const [isSubmited, setisSubmited] = useState(false)
  const [showImgView, setshowImgView] = useState(false)
  const [showInfo, setsshowInfo] = useState(false)
  const [showForm, setshowForm] = useState(false)
  const [showErrorModal, setshowErrorModal] = useState(false)
  const [errorModalText, seterrorModalText] = useState('')
  const [isLoadingSubmit, setisLoadingSubmit] = useState(false)
  const [isConfirmTerms, setIsConfirmTerms] = useState(false)
  const [showCustomsDeclarationModal, setShowCustomsDeclarationModal] = useState(false)

  //receipt data
  const [receiptFileURL, setreceiptFileURL] = useState()
  const [receiptFile, setreceiptFile] = useState()
  const [sum, setSum] = useState(0)

  const receiptViewHandler = async e => {
    setshowImgView(false)
    document.getElementById('adobe-pdf-view').innerHTML = ''
    const file = e.target.files[0]
    if (!file) return

    //check for allowed files formats
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    if (!allowedFileTypes.includes(file.type)) {
      seterrorModalText('ניתן להעלות חשבוניות כתמונות או כPDF בלבד.')
      setshowErrorModal(true)
      return
    }

    setreceiptFile(file)
    let dotFileType = file.name
    dotFileType = dotFileType.substring(dotFileType.lastIndexOf('.'), dotFileType.length)

    // diffrent UI for image and PDF
    if (dotFileType !== '.pdf') {
      setreceiptFileURL(URL.createObjectURL(file))
      setshowImgView(true)
    } else {
      // Adobe API code (Adobe PDF Embed API)
      // eslint-disable-next-line no-undef
      var adobeDCView = new AdobeDC.View({ clientId: '3daf1a0430a045879e5bf8163cad53c3', divId: 'adobe-pdf-view' })
      var reader = new FileReader()
      reader.onloadend = function (e) {
        var filePromise = Promise.resolve(e.target.result)
        // Pass the filePromise and name of the file to the previewFile API
        adobeDCView.previewFile(
          {
            content: { promise: filePromise },
            metaData: { fileName: file.name },
          },
          { embedMode: 'IN_LINE' }
          // { defaultViewMode: 'SINGLE_PAGE' }
        )
      }
      reader.readAsArrayBuffer(file)
    }

    setshowForm(true)
  }

  const submitHandler = async () => {
    //check if price exists
    if (!sum || sum < 1) {
      seterrorModalText('יש להכניס שווי חבילה.')
      setshowErrorModal(true)
      return
    }

    //check if terms confirmed
    if (!isConfirmTerms) {
      seterrorModalText('נא לאשר את ההצהרה.')
      setshowErrorModal(true)
      return
    }

    //check for allowed files formats
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    if (!allowedFileTypes.includes(receiptFile.type)) {
      seterrorModalText('ניתן להעלות חשבוניות כתמונות או כPDF בלבד.')
      setshowErrorModal(true)
      return
    }

    // Check if package value in USD is above $1000 and show customs declaration popup
    const sumInUSD = convertSumToUSD()
    if (sumInUSD > 1000) {
      setShowCustomsDeclarationModal(true)
      return
    }

    proceedWithUpload()
  }

  const proceedWithUpload = async () => {
    try {
      setisLoadingSubmit(true)
      //upload receipt to S3
      const result = await uploadReceipt(receiptFile, packageForReceiptUpload.id)
      // console.log("submitHandler - result:", result)

      //update package
      const res = await updatePackageMutation({
        packageId: packageForReceiptUpload.id,
        updateParam: {
          buyingReciptKey: result.Location,
          price: sum,
          falseReceiptDate: `New upload: ${new Date().toISOString().split('T')[0]}`,
          warehouse: packageForReceiptUpload.warehouse,
        },
      })
      const updatedPkg = res.data.response.Attributes

      //update redux for payment
      await dispatch(setPackageForPayment(updatedPkg))

      setisLoadingSubmit(false)
      setisSubmited(true)
      localStorage.removeItem('upload-page-package')
      window.scrollTo(0, 0)

      //Redirect to payment page.
      //Redirect to my packages if the office "false receipt" (meaning the package is paid) or if the user has requests
      if (
        packageForReceiptUpload.isPaid ||
        packageForReceiptUpload.isPhotoRequestActive ||
        packageForReceiptUpload.isReturnRequestActive ||
        packageForReceiptUpload.isShrinkRequestActive
      ) {
        setTimeout(() => {
          history.push('/personal-info/myPackages')
        }, 1500)
      } else {
        setTimeout(() => {
          history.push('/payment')
        }, 1500)
      }
    } catch (error) {
      setisLoadingSubmit(false)
      console.log('Error uploading file: ', error)

      seterrorModalText('הייתה שגיאה בהעלאת הקובץ. אנא נסה שנית או פנה לשירות הלקוחות.')
      setshowErrorModal(true)
    }
  }

  const toggleInfoClass = () => {
    setsshowInfo(!showInfo)
  }

  const getSumWarning = () => {
    switch (packageForReceiptUpload.warehouse) {
      case 'GR':
        if (sum >= 1100) return 'שווי החבילה גבוה. שים לב שלא טעית.'
        else if (sum <= 40 && sum !== 0) return 'שווי החבילה נמוך. שים לב שלא טעית.'
        break
      case 'USA':
        if (sum >= 300) return 'שווי החבילה גבוה. שים לב שלא טעית.'
        else if (sum <= 30 && sum !== 0) return 'שווי החבילה נמוך. שים לב שלא טעית.'
        break
      case 'UK':
        if (sum >= 230) return 'שווי החבילה גבוה. שים לב שלא טעית.'
        else if (sum <= 22 && sum !== 0) return 'שווי החבילה נמוך. שים לב שלא טעית.'
        break
    }
  }

  const getLocalCurrency = () => {
    switch (packageForReceiptUpload.warehouse) {
      case 'GR':
        return 'אירו'
      case 'USA':
        return 'דולר'
      case 'UK':
        return 'פאונד'
    }
  }

  const convertSumToUSD = () => {
    if (!sum || sum === 0) return 0

    switch (packageForReceiptUpload.warehouse) {
      case 'GR': // Euro to USD
        return sum * EURToUSD
      case 'USA': // Already in USD
        return sum
      case 'UK': // GBP to USD
        return sum * GBPToUSD
      default:
        return sum // fallback to original sum
    }
  }

  return (
    <div className='rup-container'>
      {!isSubmited ? (
        <>
          <div className='rup-top'>
            <div className='rup-return-cont' onClick={() => history.push('/personal-info/myPackages')}>
              <img src={returnIcon} className='rup-return-img' />
              <div>חזרה לחבילות שלי</div>
            </div>

            <div
              className='btn yellow-bcg'
              onClick={() => {
                document.getElementById(`receiptInput`).click()
              }}
            >
              {receiptFile ? 'תיקון חשבונית' : 'העלאת חשבונית'}
            </div>
            <input type='file' id={'receiptInput'} style={{ display: 'none' }} onChange={receiptViewHandler} />
            <div className='rup-know'>
              רוצים לדעת איך נראית חשבונית תקנית?{' '}
              <a href='https://www.instagram.com/p/Cao7zAmscWE/?igshid=YmMyMTA2M2Y=' target={'_blank'} rel='noreferrer'>
                לחצו כאן
              </a>
            </div>

            <div className='rup-file-view-cont'>
              {showImgView && <img src={receiptFileURL} alt='receipt-view' />}
              <div id='adobe-pdf-view' className='adobe-pdf-view'></div>
            </div>
          </div>

          {showForm && (
            <>
              <div className='rup-sum-cont'>
                <div>
                  מה שווי החבילה?
                  <span className='rup-sum-i' onClick={toggleInfoClass}>
                    <img src={infoIcon} alt='info' />
                  </span>
                </div>
                <div className={showInfo ? 'rup-sum-desc infoActive1' : 'rup-sum-desc'}>
                  <span>הסכום הכולל של שווי הפריטים בלבד! </span>
                  <span style={{ fontWeight: 'bold' }}>ללא מיסים מקומיים ועלויות שילוח מקומיות.</span>
                  <br />
                  <span>
                    את הסכום נדרש לכתוב <span style={{ fontWeight: 'bold' }}>במטבע המקומי</span> של המדינה ממנה הזמנת (דולר, אירו וכדו').
                  </span>
                  {/* <br />
                  <img src={receiptExample} alt="receipt-example" height={'65px'} /> */}
                </div>
                <input type='number' placeholder={getLocalCurrency()} onChange={e => setSum(parseInt(e.target.value))} />
                <br />
                <div className='rup-sum-warning'>
                  <span>{getSumWarning()}</span>
                </div>
              </div>

              <div className='rup-bottom-cont'>
                <div>
                  <span style={{ fontWeight: 'bold', fontSize: '22px', marginBottom: '6px' }}>שים לב!❤️</span>
                  <br />
                  <span>הסכום שהוצהר והחשבונית המצורפת ישמשו לשחרור החבילה מהמכס בישראל.</span>
                  <br />
                  <span style={{ fontWeight: 'bold' }}>וודאו שהפרטים שהזנתם נכונים!</span>
                  <br />
                  במידה והצהרתכם לא תואמת את שווי ההזמנה, המכס עלול לגבות תשלומים נוספים לשחרור החבילה ואף לעכב את השילוח בהתאם לתנאי השימוש
                  שלנו.
                </div>
                <div className='rup-checkbox-cont'>
                  <input type='checkbox' onChange={e => setIsConfirmTerms(e.target.checked)} />
                  <div> הבנתי! בואו נתקדם...</div>
                </div>
                <div style={{ height: '40px' }}>
                  {isLoadingSubmit ? (
                    <Spinner animation='border' variant='primary' />
                  ) : (
                    <Button block disabled={isLoadingSubmit} onClick={submitHandler} variant='primary' style={{ width: '226px' }}>
                      אישור החשבונית ומעבר לתשלום
                    </Button>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <div className='rup-success'>
          <img src={checkMark} alt='receipt-upload-successful' />
          <h4>חשבונית הועלתה בהצלחה!</h4>
        </div>
      )}

      <Modal show={showErrorModal} onHide={() => setshowErrorModal(false)} style={{ direction: 'rtl', textAlign: 'center' }}>
        <Modal.Header style={{ textAlign: 'center' }}>
          <div style={{ width: '100%' }}>
            <Modal.Title>שים לב!</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>{errorModalText}</Modal.Body>
        <Modal.Footer style={{ justifyContent: 'center' }}>
          <Button variant='danger' onClick={() => setshowErrorModal(false)}>
            סגור
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showCustomsDeclarationModal}
        onHide={() => setShowCustomsDeclarationModal(false)}
        style={{ textAlign: 'center', direction: 'rtl' }}
        centered={true}
      >
        <Modal.Header>
          <div style={{ width: '100%' }}>
            <Modal.Title>הודעה חשובה</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body style={{ textAlign: 'right', lineHeight: '1.6' }}>
          <div>
            בהתאם לחוק, חבילות בשווי מעל 1000$ נדרשות במילוי טופס ייפוי כח לעמיל המכס לטובת שחרורם.
            <br />
            <br />
            קישור למילוי הטופס ישלח אליכם ע"י עמיל המכס. שירות זה כרוך בעלות של 300 ש"ח אותם נדרש לשלם ישירות לעמיל המכס.
          </div>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: 'center', gap: '10px' }}>
          <Button variant='secondary' onClick={() => setShowCustomsDeclarationModal(false)}>
            חזור
          </Button>
          <Button
            variant='primary'
            onClick={() => {
              setShowCustomsDeclarationModal(false)
              proceedWithUpload()
            }}
          >
            אישור
          </Button>
        </Modal.Footer>
      </Modal>

      <TheFooter />
    </div>
  )
}
